module.exports = __webpack_public_path__ + "img/XLS.0dfbb827.svg";